export const styledBoxOptions: StyledBoxOptions[] = [
  {
    text: 'Swap Box',
    value: 'swap_box',
  },
  {
    text: 'Styled box',
    value: 'styled_box',
  },
  {
    text: 'Studio',
    value: 'studio',
  },
  {
    text: 'After Sales',
    value: 'after_sales',
  },
  {
    text: 'Promotion',
    value: 'promotion',
  },
  {
    text: 'Supplier Return',
    value: 'supplier_return',
  },
  {
    text: 'Swipe-to-shop',
    value: 'swipe_to_shop',
  },
  {
    text: 'Shopify',
    value: 'shopify',
  },
  {
    text: 'Styling fee',
    value: 'styling_fee',
  },
  {
    text: 'Other',
    value: 'other',
  },
];

export interface StyledBoxOptions {
  text?: string,
  value?: string,
}
